// @flow
export default function degToRad(degrees: number): number {
    return degrees * Math.PI / 180;
}